import { memo, ReactNode } from 'react';

import cn from 'classnames';

import { noop } from 'helpers/utils';
import { CrossIconSymbol, AngleLeft } from 'styles/assets/icons';

import styles from './menuBackButton.module.scss';

interface MenuBackButtonProps {
  onBackButtonClick: () => void;
  text: string | ReactNode;
  onRightButtonClick?: () => void;
  rightIcon?: ReactNode;
  showRightIcon?: boolean;
  showCloseIcon?: boolean;
  onCrossIconClick?: () => void;
  className?: string;
  headerTextClassName?: string;
}

const MenuBackButton = memo(
  ({
    onBackButtonClick,
    text,
    onRightButtonClick,
    rightIcon,
    showRightIcon,
    showCloseIcon,
    onCrossIconClick,
    className = '',
    headerTextClassName = '',
  }: MenuBackButtonProps) => {
    return (
      (<div
        className={cn(styles['back-button-header'], className)}
        data-palette="MenuBackButton">
        <button
          data-testid="menu-back-button"
          type="button"
          className={`${styles['back-button']} ${styles.ripple}`}
          onClick={onBackButtonClick}
        >
          <AngleLeft className={styles.icon} />
        </button>
        <div className={cn(styles['header-text'], headerTextClassName)}>{text}</div>
        {showRightIcon && (
          <button
            type="button"
            data-testid="menu-right-button"
            className={styles['right-button']}
            onClick={onRightButtonClick}
            data-palette="MenuBackButton">
            {rightIcon}
          </button>
        )}
        {showCloseIcon && (
          <span
            tabIndex={0}
            role="button"
            onKeyDown={noop}
            data-testid="menu-cross-icon"
            className={styles['cross-icon']}
            onClick={onCrossIconClick}
            data-palette="MenuBackButton">
            <CrossIconSymbol />
          </span>
        )}
      </div>)
    );
  }
);

MenuBackButton.displayName = 'MenuBackButton';

export { MenuBackButton };
